<template>
  <div>
    <v-dialog v-model="editDialog" width="700" @input="closeDialog">
      <v-form ref="form" v-model="valid" v-on:submit.prevent>
        <v-card>
          <v-card-text class="border-bottom">
            <div class="row pt-1 border-bottom">
              <div class="col-md-12">
                <div class="d-flex justify-space-between align-center mt-2">
                  <SvgIcon class="text-2xl font-semibold" :text="this.dealId ? 'Edit Deal':'Add Deal' " style="color: black">
                  </SvgIcon>
                  <v-btn fab x-small class="shadow-0" @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div>
              <p class="banner-text mt-6">Client Information</p>
            </div>
            <v-row dense class="mt-2">
              <div class="col-md-12">
                <div class="row row--dense mx-2">
                  <div class="col-md-12">
                    <label for="">Client Name </label>
                    <v-text-field
                        v-model="deal.client_name"
                        :rules="[(v) => !!v || 'Client name is required']"
                        class="q-text-field shadow-0" outlined dense hide-details="auto"
                    ></v-text-field>
                  </div>
                  <div class="col-md-12" v-if="!deal.id">
                    <label for="">Venue</label>
                    <v-select
                        class="q-text-field shadow-0"
                        outlined
                        dense
                        hide-details="auto"
                        :menu-props="{ bottom: true, offsetY: true }"
                        item-value="id"
                        item-text="name"
                        :items="venues"
                        v-model="deal.venue_id"
                        :rules="[(v) => !!v || 'Venue Id is required']"
                        validate-on-blur
                    ></v-select>
                  </div>
                  <v-col cols="12" md="6">
                    <label for="">
                      Start date of agreement
                    </label>
                    <date-field
                        v-model="deal.contract_start_date"
                        :back-fill="true"
                        :dense="true"
                        :rules="[(v) => !!v || 'Start date is required']"
                        class-name="q-text-field"
                        hide-details="auto"
                        label=""
                        outlined
                        required
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <label for="">
                      End date of agreement
                    </label>
                    <date-field
                        v-model="deal.contract_end_date"
                        :back-fill="false"
                        :dense="true"
                        :rules="[(v) => !!v || 'End date is required']"
                        class-name="q-text-field"
                        hide-details="auto"
                        label=""
                        :minDate="deal.contract_start_date"
                        outlined
                        required
                    />
                  </v-col>

                  <v-col class="col-md-4">
                    <label for="">Value Of Deal </label>
                    <v-text-field
                        class="q-text-field shadow-0"
                        outlined
                        dense
                        prefix="AED"
                        type="number"
                        hide-details="auto"
                        v-model="deal.value_of_deal"
                        :rules="[(v) => !!v || v === 0 || 'Value of deal is required']"
                    />
                  </v-col>
                  <div class="col-md-4">
                    <label for="">No. of Installments</label>
                    <v-select
                        class="q-text-field shadow-0"
                        outlined
                        dense
                        hide-details="auto"
                        :menu-props="{ bottom: true, offsetY: true }"
                        item-value="id"
                        item-text="name"
                        :items="[{id: 1, name: '1'},{id: 2, name: '2'},{id: 3, name: '3'},{id: 4, name: '4'},{id: 6, name: '6'},{id: 12, name: '12'}]"
                        v-model="deal.total_installments"
                        :rules="[(v) => !!v || 'Installment Count is required']"
                        validate-on-blur
                    ></v-select>
                  </div>
                  <div class="col-md-4">
                    <label for="">Payment Gateway</label>
                    <v-select
                        class="q-text-field shadow-0"
                        outlined
                        dense
                        hide-details="auto"
                        :menu-props="{ bottom: true, offsetY: true }"
                        item-value="id"
                        item-text="name"
                        :items="pgItems"
                        v-model="deal.payment_gateway"
                        :rules="[(v) => !!v || 'Payment Gateway is required']"
                        validate-on-blur
                    ></v-select>
                  </div>
                  <v-col cols="12" md="4">
                    <FileInput
                        v-model="deal.agreement_file"
                        :default-value="deal.agreement_file_path"
                        :required="!deal.agreement_file_path"
                        label="Agreement"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <FileInput
                        v-model="deal.trade_license"
                        :default-value="deal.trade_license_path"
                        :required="!deal.trade_license_path"
                        label="Trade License"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <FileInput
                        v-model="deal.tax_certificate"
                        :default-value="deal.tax_certificate_path"
                        :required="!deal.tax_certificate_path"
                        label="Tax certificate"
                    />
                  </v-col>
                </div>
              </div>
            </v-row>
            <div>
              <p class="banner-text mt-6 mb-2">Contact Person Information</p>
            </div>

            <div class="row row--dense mx-2">
              <div class="col-md-12">
                <label for="">Name</label>
                <v-text-field
                    v-model="deal.contact_person_name"
                    :rules="[(v) => !!v || 'Name is required']"
                    class="q-text-field shadow-0" outlined dense
                    hide-details="auto"
                ></v-text-field>
              </div>

              <div class="col-md-6">
                <label for="">Mobile Number </label>
                <mobile-number-field
                    v-model="deal.contact_person_mobile"
                    :refresh-country="true"
                    :variant="1"
                    :dense="true"
                    :outlined="true"
                />
              </div>
              <div class="col-md-6">
                <label for="">Email </label>
                <v-text-field
                    class="q-text-field shadow-0" outlined dense
                    validate-on-blur
                    hide-details="auto"
                    v-model="deal.contact_person_email"
                    :rules="[(v) => !!v || 'Email is required',(v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',]"
                ></v-text-field>
              </div>
            </div>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color=" "
                class="ma-2  "
                text
                @click="closeDialog"
            > Close
            </v-btn>
            <v-btn
                color=" darken-1"
                class="ma-2 white--text blue-color"
                @click="saveDeal"
                text
            >Save Deal
            </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>

import MobileNumberField from "@/components/Fields/MobileNumberField.vue";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import FileInput from "@/components/Fields/FileInput.vue";

export default {
  components: {
    FileInput,
    MobileNumberField,
    SvgIcon,
  },
  props: {
    propDeal: {
      type: Object, default: () => {
      }
    },
    editDialog: {type: Boolean, default: false},
    salesPersonId: {type: Number, default: null},
    dealId: {type: Number, default: null},
  },
  watch: {
    dealId: {
      immediate: true,
      handler(newId) {
        if(newId ){
          this.loadDealDetails()
        }
      },
    },
  },
  mounted() {

    if (this.$store.getters.getServices.status == false) {
      this.$store.dispatch("loadVenues");
    }
  },


  computed: {
    venues() {
      return this.$store.getters.getVenues.data;
    },
  },
  data() {
    return {
      pgItems: [
        {
          id: 'Qode',
          name: 'Qode',
        },
        {
          id: 'EPG',
          name: 'EPG',
        },
        {
          id: 'NI',
          name: 'NI',
        },
        {
          id: 'Others',
          name: 'Others',
        },
      ],
      deal: {
        id: null,
        client_name: null,
        contract_start_date: null,
        contract_end_date: null,
        payment_gateway: null,
        agreement_file: null,
        agreement_file_path: null,
        trade_license: null,
        trade_license_path: null,
        tax_certificate: null,
        tax_certificate_path: null,
        contact_person_name: null,
        contact_person_email: null,
        contact_person_mobile: null,
        value_of_deal: null,
        total_installments: null,
        venue_id: null,
      },
      valid: false,
    };
  },
  methods: {
    closeDialog() {
      this.deal = {
        id: null,
        client_name: null,
        contract_start_date: null,
        contract_end_date: null,
        payment_gateway: null,
        agreement_file: null,
        agreement_file_path: null,
        trade_license: null,
        trade_license_path: null,
        tax_certificate: null,
        tax_certificate_path: null,
        contact_person_name: null,
        contact_person_email: null,
        contact_person_mobile: null,
        value_of_deal: null,
        total_installments: null,
      }
      this.$emit('closeDeal')
    },
    saveDeal(event) {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }
      let formData = new FormData();
       if(this.salesPersonId){
         formData.set("sales_person_id", this.salesPersonId);
       }
      formData.set("client_name", this.deal.client_name);
      formData.set("contract_start_date", this.deal.contract_start_date);
      formData.set("contract_end_date", this.deal.contract_end_date);

      formData.set("payment_gateway", this.deal.payment_gateway);
      if(this.deal.agreement_file){
        formData.set("agreement_file", this.deal.agreement_file);
      }if(this.deal.trade_license){
        formData.set("trade_license", this.deal.trade_license);
      }if(this.deal.tax_certificate){
        formData.set("tax_certificate", this.deal.tax_certificate);
      }
      formData.set("contact_person_name", this.deal.contact_person_name);
      formData.set("contact_person_email", this.deal.contact_person_email);
      formData.set("contact_person_mobile", this.deal.contact_person_mobile);
      formData.set("value_of_deal", this.deal.value_of_deal);
      formData.set("total_installments", this.deal.total_installments);
      if(this.deal?.venue_id){
        formData.set("venue_id", this.deal.venue_id);
      }
      if(this.deal.id){
        formData.set("deal_id", this.deal.id);
      }
      this.showLoader("Verifying and saving credentials");
      this.$http({
        url: "sales-team/deals",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
          .then((response) => {
            if (response.status === 200) {
              this.showSuccess("Deal Saved Successfully.");
              this.closeDialog()
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.hideLoader();
          });
    },
    loadDealDetails(){
      this.showLoader("Loading Deal details");
      this.$http
          .get(`sales-team/deals/details/${this.dealId}`)
          .then((response) => {
            this.hideLoader();

            if (response.status == 200 && response.data.status == true) {
              const data = response.data.data;
              if (data) {
                this.deal.id = data.id;
                this.deal.client_name = data.client_name;
                this.deal.contract_start_date = data.contract_start_date;
                this.deal.contract_end_date = data.contract_end_date;
                this.deal.payment_gateway = data.payment_gateway;
                this.deal.agreement_file_path = data.agreement_file;
                this.deal.trade_license_path = data.trade_license;
                this.deal.tax_certificate_path = data.tax_certificate;
                this.deal.contact_person_name = data.contact_person_name;
                this.deal.contact_person_email = data.contact_person_email;
                this.deal.contact_person_mobile = data.contact_person_mobile;
                this.deal.total_installments = data.total_installments;
                this.deal.value_of_deal = data.value_of_deal;
              }
            }
          })
          .catch((error) => {
            this.errorChecker(error);
            this.gotoSalesTeam();
            this.hideLoader();

          });
    }
  }
}
</script>

<style scoped>
.banner-text {
  background: rgba(232, 241, 244, 0.7);
  color: black;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

}
</style>